import { Gallery } from "components/Gallery/MainPages/Gallery";
import GroupsDetails from "components/Pages/GroupsDetails";
import { MainFooter } from "components/MainFooter/MainFooter";
import Header from "components/Pages/Header";
import HeaderDescription2 from "components/Pages/HeaderDescription2";
import React, { useEffect, useState } from "react";
import RightLeftDescription from "./RightLeftDescription";
import { _project } from "state/store.projects";
import { get, useGet } from "state/jotai";
import RelatedUnits from "components/Gallery/MainPages/RelatedUnits";
import { Box, useMediaQuery } from "@mui/material";
import { _bootstrap } from "state/store.bootstrap";
import { useTranslation } from "react-i18next";
import { F_PROPERTY } from "api/full_eido_api";
import { useFetch } from "hooks/fetch/useFetch";
import { useBreak } from "hooks/useBreak";
import Scrollbar from "react-scrollbars-custom";
import BackgroundImagePreloader from "main/Preloading/BackgroundFullEidoWebsiteImageLoader";

export const Propertypage = () => {
  const isDesktop = useBreak("md_up");

  return (
    <>
      {isDesktop ? (
        <Scrollbar
          noScrollX
          style={{ width: "100%" }}
          contentProps={{ style: { paddingRight: 0, marginRight: 0 } }}
          scrollerProps={{
            style: {
              paddingRight: 0,
              marginRight: 0,
            },
          }}
          trackYProps={{
            renderer: (props) => {
              const { elementRef, ...restProps } = props;
              return (
                <span
                  {...restProps}
                  ref={elementRef}
                  className="trackY"
                  style={{ ...restProps.style }}
                />
              );
            },
          }}
        >
          <RenderComponent />
        </Scrollbar>
      ) : (
        <RenderComponent />
      )}
    </>
  );
};

const RenderComponent = () => {
  const rawUnits = get(_project, "unitsraw", "Units");
  const [relatedUnits, setRelatedUnits] = useState([]);
  const {
    i18n: { language },
  } = useTranslation();
  const [propertyData, setPropertyData] = useState({});
  const pid = useGet(_bootstrap).projectids?.[0] || null;
  const propertypageData = useFetch({ url: F_PROPERTY(pid, language) }).D;
const isLargeDesktop = useMediaQuery("(min-width:1330px)");
// console.log(propertyData?.GallerySlider?.ListOfPhotos,"sjsjj")
// console.log(propertyData,"sksk")
  useEffect(() => {
    if (Object.keys(propertypageData || {}).length) {
      setPropertyData(propertypageData);

      const ru = rawUnits.filter(
        (u) =>
          propertypageData?.UnitSlider?.unitIds?.includes(u.UnitID) &&
          u?.Data?.UnitStatusID?.Value !== 30 &&
          u?.Data?.UnitStatusID?.Value !== 40
      );

      if (ru.length) {
        setRelatedUnits(ru);
      }
    }
  }, [propertypageData, rawUnits, language]);

  return (
    <div style={{ width: "100%" }}>
        {/* 🔥 Preload top 5 gallery images invisibly */}
      <BackgroundImagePreloader imageUrls={propertyData?.GallerySlider?.ListOfPhotos} limit={5} />
      <Header page="propertypage" {...propertyData}/>
      <HeaderDescription2 page="propertypage" {...propertyData} />

     { Boolean(propertyData?.GallerySlider?.ListOfPhotos?.length) && <Gallery {...propertyData} page="propertypage"/>} 


      {
        Boolean(relatedUnits?.length) && <Box sx={{ pt: '31.5px', py: '32px' }} >
          <RelatedUnits relatedUnits={relatedUnits} />
        </Box>
      }
     
      <Box
         sx={{
        padding: {
          xs: "40px 16px", // mobile
          sm: "40px 24px", // tablets & small desktops
        },
        ...(isLargeDesktop && {
          padding: "64px 24px", // only for >= 1330px
        }),
      }}
      >
        <RightLeftDescription page="propertypage" {...propertyData} />
      </Box>
      <div style={{ marginTop: "40px" }}>
        <MainFooter />
      </div>
    </div>
  );
};
